import { Link } from 'react-router-dom'
import logo from '../logo.jpg'
import { isPhone } from '../common/constants'

interface Props {
  shrink?: boolean
}

export function Logo({ shrink = false }: Props) {
  return isPhone ? null : (
    <div
      className={`flex items-center flex-shrink-0 text-white mr-6 ${shrink ? 'h-[40px]' : 'h-[150px]'}`}
    >
      <Link to="/">
        <img src={logo} className={`${shrink ? 'h-[40px]' : 'h-[150px]'} w-auto`} alt="logo" />
      </Link>
    </div>
  )
}
